import { normalizeLink } from "../extensions/url/utils";
export const generateIconhorseFaviconUrl = (normalizedLink) => {
    return `https://icon.horse/icon/?uri=${normalizedLink}`;
};
export const generateGoogleFaviconUrl = (normalizedLink) => {
    return `https://www.google.com/s2/favicons?sz=16&domain_url=${normalizedLink}`;
};
export const getFaviconServiceUrl = (href) => {
    try {
        const normalizedHref = normalizeLink(href);
        // eslint-disable-next-line n/no-unsupported-features/node-builtins
        const { origin } = new URL(normalizedHref);
        return generateIconhorseFaviconUrl(origin);
    }
    catch (e) {
        return "";
    }
};
